import React from 'react';
import ISRHomePage from '../Pages/ISRHomePage';


const ISRProvider = (props: any) => {

    return (
        <React.Fragment>
            <ISRHomePage  />
        </React.Fragment>
    );
}

export default ISRProvider;